import { EChannel } from 'core/model/enums/channel.enum';
import { ImageRoutes } from './image-routes';

interface IChannelTheme {
  name: string;
  logo: string;
  logoAlt: string;
  profileBanner: string;
  title: string;
  logoFooter: string;
  maintenanceImage: string;
}

export const CHANNEL_THEMES: Record<EChannel, IChannelTheme> = {
  [EChannel.DIADIA]: {
    name: 'diadia',
    logo: ImageRoutes.LOGO_MAIN_HEADER_DIADIA,
    logoAlt: 'Logo Diadía',
    logoFooter: ImageRoutes.LOGO_FOOTER_DIADIA,
    profileBanner: ImageRoutes.PROFILE_BANNER_DIADIA,
    title: 'Diadía',
    maintenanceImage: ImageRoutes.MAINTENANCE_DIADIA,
  },
  [EChannel.INSUMA]: {
    name: 'insuma',
    logo: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    logoAlt: 'Logo Insuma',
    logoFooter: ImageRoutes.LOGO_FOOTER_INSUMA,
    profileBanner: ImageRoutes.PROFILE_BANNER_INSUMA,
    title: 'Insuma',
    maintenanceImage: ImageRoutes.MAINTENANCE_INSUMA,
  },
  [EChannel.ALICORP]: {
    name: 'alicorp',
    logo: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    logoAlt: 'Logo Aliados de tu desarrollo',
    logoFooter: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    profileBanner: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    title: 'Aliados de tu desarrollo',
    maintenanceImage: ImageRoutes.MAINTENANCE_INSUMA,
  },
};

export const CHANNEL_FAVICONS: Record<EChannel, string> = {
  [EChannel.DIADIA]: '/favicon-diadia.ico',
  [EChannel.INSUMA]: '/favicon-insuma.ico',
  [EChannel.ALICORP]: '/favicon.ico',
};

export const CHANNEL_MANIFESTS: Record<EChannel, string> = {
  [EChannel.DIADIA]: '/manifest-diadia.json',
  [EChannel.INSUMA]: '/manifest-insuma.json',
  [EChannel.ALICORP]: '/manifest.json',
};
export const CHANNEL_APPLE_TOUCH_ICONS: Record<EChannel, string> = {
  [EChannel.DIADIA]: '/apple-touch-icon-diadia.png',
  [EChannel.INSUMA]: '/apple-touch-icon-insuma.png',
  [EChannel.ALICORP]: '/apple-touch-icon.png',
};

export const CHANNEL_META_LINKS: Record<EChannel, string> = {
  [EChannel.DIADIA]: '/assets/images/meta-link-diadia.png',
  [EChannel.INSUMA]: '/assets/images/meta-link-insuma.png',
  [EChannel.ALICORP]: '/assets/images/meta-link.png',
};
